/**
 * @author yan st
 * @date 2022-08-16 08:40
 * @Description:
 */
import {qspost} from '@/plugins/axios'

/*
*   首页统计数量
* */
export const statistics = (mid) => qspost('/api/home/statistics', {mid})

/*
*   首页统计图
* */
export const statisticsCharts = (mid) => qspost('/api/home/statisticsCharts', {mid})

/*
*   获取当前组织的专家分类
* */
export const getExpertType = (mid) => qspost('/api/Invitation/getExpertType', {mid})

export const getExpertTypeTwo = (show_id) => qspost('/api/Invitation/getExpertType', {show_id})


/*
*   提交信息（组织添加专家、邀请专家注册）
* */
export const sub = (
  show_id,register_type,pic,name,sex,type_id,political_status,birthday,educational_background,nationality
  ,mailing_address,id_number,company,phone_number,professional_title,industry,job,desc,remark
) => qspost('/api/Invitation/register', {
  show_id,register_type,pic,name,sex,type_id,political_status,birthday,educational_background,nationality
  ,mailing_address,id_number,company,phone_number,professional_title,industry,job,desc,remark
})

/*
*   提交信息（组织添加专家、邀请专家注册）
* */
export const edit = (
  mid,id,pic,name,sex,type_id,political_status,birthday,educational_background,nationality
  ,mailing_address,id_number,company,phone_number,professional_title,industry,job,desc,remark
) => qspost('/api/expert/edit', {
  mid,id,pic,name,sex,type_id,political_status,birthday,educational_background,nationality
  ,mailing_address,id_number,company,phone_number,professional_title,industry,job,desc,remark
})


/*
*   专家领域 添加 编辑
* */
export const field = (mid,name,id) => qspost('/api/type/edit', {mid,name,id})

/*
*   专家领域 删除
* */
export const fieldDel = (mid,id) => qspost('/api/type/del', {mid,id})

/*
*   专家领域编辑
* */
export const fieldlist = (mid,page,limit) => qspost('/api/type/query', {mid,page,limit})

/*
*   专家领域编辑
* */
export const Expertlist = (
  mid,search_state,search_type,search_name,page,limit
) => qspost('/api/Expert/query', {
  mid,search_state,search_type,search_name,page,limit
})

/*
*   专家删除
* */
export const expertDel = (mid,id) => qspost('/api/expert/del', {mid,id})

/*
*   专家审核
* */
export const examine = (mid,id,state,state_remark) => qspost('/api/expert/setState', {mid,id,state,state_remark})

/*
*   专家详情
* */
export const expertDetail = (mid,id) => qspost('/api/expert/detail', {mid,id})

/*
*   更新专家显示隐藏状态
* */
export const expertSetShow = (mid,id) => qspost('/api/expert/setShow', {mid,id})

/*
*   更改展示设置
* */
export const setSetting = (
  mid,is_tui,is_org,login_show,login_yuyue
) => qspost('/api/yuyue/setSetting', {
  mid,is_tui,is_org,login_show,login_yuyue
})

/*
*   获取展示设置
* */
export const getSetting = (mid) => qspost('/api/yuyue/getSetting', {mid})


/*
*   专家显示页面
* */
export const indexShow = (
  show_id,expert_recommend_type,expert_recommend_page,expert_recommend_limit,expert_type,expert_list_page,expert_list_limit
) => qspost('/api/index.show/index', {
  show_id,expert_recommend_type,expert_recommend_page,expert_recommend_limit,expert_type,expert_list_page,expert_list_limit
})

/*
*   专家显示页面 机构专家列表
* */
export const index_page = (
  mid,show_id,expert_list_name,expert_list_type,expert_list_page,expert_list_limit
) => qspost('/api/index.show/index_page', {
  mid,show_id,expert_list_name,expert_list_type,expert_list_page,expert_list_limit
})

/*
*   专家显示页面 推荐专家列表
* */
export const index_page_recommend = (
  mid,show_id,expert_recommend_name,expert_recommend_type,expert_recommend_page,expert_recommend_limit
) => qspost('/api/index.show/index_page_recommend', {
  mid,show_id,expert_recommend_name,expert_recommend_type,expert_recommend_page,expert_recommend_limit
})

/*
*   热门专家列表
* */
export const hot = (show_id,page,limit) => qspost('/api/index.show/hot', {show_id,page,limit})

/*
*   专家详情
* */
export const zjDetail = (id) => qspost('/api/index.show/detail', {id})

/*
*   预约专家
* */
export const yuyueSub = (
  mid,show_id,qid,name,phone,content
) => qspost('/api/index.expert/yuyue', {
  mid,show_id,qid,name,phone,content
})


/*
*   专家信息-预约信息
* */
export const getExpert = (mid,id) => qspost('/api/yuyue/getExpert', {mid,id})

/*
*   专家信息-预约列表
* */
export const expertYuyue = (
  mid,qid,search_name,page,limit
) => qspost('/api/yuyue/expertYuyue', {
  mid,qid,search_name,page,limit
})

/*
*   处理预约信息
* */
export const changeStatus = (mid,id) => qspost('/api/yuyue/changeStatus', {mid,id})

/*
*   删除预约信息
* */
export const delYuyue = (mid,id) => qspost('/api/yuyue/delYuyue', {mid,id})


/*
*   删除预约信息
* */
export const yuyueList = (mid,search_name,page,limit) => qspost('/api/yuyue/index', {mid,search_name,page,limit})


/*
*   邀请海报
* */
export const poster = (mid,url,update) => qspost('/api/invitation/poster', {mid,url,update})

/*
*   机构信息-修改
* */
export const setParentInfo = (
  mid,morglogo,morgname,contacts,morgtel,address,morgemail,morgurl,morgdesc
) => qspost('/api/index/setParentInfo', {
  mid,morglogo,morgname,contacts,morgtel,address,morgemail,morgurl,morgdesc
})

/*
*   机构信息-详情
* */
export const getParentInfo = (mid) => qspost('/api/index/getParentInfo', {mid})

/*
*   修改密码
* */
export const updatePassword = (mid,oldPass,pass,repass) => qspost('/api/index/updatePassword', {mid,oldPass,pass,repass})


/*
*   机构信息-详情
* */
export const getMoBAN = (mid) => qspost(`/api/expert/getExcelDemo/mid/${mid}.html`, {})













































































